export const demoMostClickedFeedItems = {
    "items": [
        {
            "id": 168622283,
            "sku": "483f6d717ccaa4200f5759704c54f02a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-nirvana-face-license-t-shirt/MZZ86578.html?color=173",
            "name": "Oversized Nirvana Face License T-shirt",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "white",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/mzz86578_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "22.00",
            "sale_price": "15.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 68,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 11,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 1,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 1,
                        "percent": 100
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168623557,
            "sku": "ce43f09bc07de6be637cdc032cc74706-1057",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1057,
            "link": "https://www.boohoo.com/heart-print-button-front-cami-trousers-pyjama-set/GZZ76630.html?color=155",
            "name": "Heart Print Button Front Cami & Trousers Pyjama Set",
            "status": 1,
            "version": "202503251201",
            "gender": "WOMEN",
            "color": "pink",
            "openai_category": null,
            "category_id": null,
            "category": "Pyjama Sets",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/gzz76630_pink_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "25.00",
            "sale_price": "20.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/NM0NiqGEg1NtEFLR5JHjy/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/NM0NiqGEg1NtEFLR5JHjy/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:03:26.000000Z",
            "updated_at": "2025-03-25T12:02:39.000000Z",
            "blocks": null,
            "brand": {
                "id": 870,
                "name": "Boohoo"
            },
            "feeder_brand": {
                "id": 870,
                "name": "Boohoo"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 1,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722708,
            "sku": "5501110d3af819509f7a9d614daf7c2f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/long-sleeve-contrast-collar-knitted-shirt-in-black/BMM75282.html?color=105",
            "name": "Long Sleeve Contrast Collar Knitted Shirt In Black",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Long-sleeved t-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm75282_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 21,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 1,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622293,
            "sku": "9b1f9e4245de30309bd946188d2e4cdf-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-virtues-graphic-t-shirt/AMM00817.html?color=105",
            "name": "Oversized Virtues Graphic T-shirt",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/amm00817_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "15.00",
            "sale_price": "10.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_QNRbf4J8OYv7TjBdgkbfW/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_QNRbf4J8OYv7TjBdgkbfW/original.jpg",
            "tags": {
                "color": "turquoise",
                "category": "t-shirt",
                "attributes": [
                    {
                        "type": "neckline_type",
                        "values": [
                            {
                                "score": 0.28114,
                                "attribute": "round-neck"
                            }
                        ]
                    },
                    {
                        "type": "tops_fit",
                        "values": [
                            {
                                "score": 0.95615,
                                "attribute": "oversized-tops"
                            }
                        ]
                    },
                    {
                        "type": "tops_length",
                        "values": [
                            {
                                "score": 0.66946,
                                "attribute": "thigh-length"
                            }
                        ]
                    },
                    {
                        "type": "colors",
                        "values": [
                            {
                                "score": 0.61568,
                                "attribute": "turquoise"
                            }
                        ]
                    },
                    {
                        "type": "pattern",
                        "values": [
                            {
                                "score": 0.28048,
                                "attribute": "leaf"
                            }
                        ]
                    },
                    {
                        "type": "style",
                        "values": [
                            {
                                "score": 0.99902,
                                "attribute": "casual"
                            }
                        ]
                    },
                    {
                        "type": "occasion",
                        "values": [
                            {
                                "score": 0.5,
                                "attribute": "nightout"
                            }
                        ]
                    }
                ]
            },
            "ximilar_tags": {
                "Age": "adult",
                "Belt": "no belt",
                "Hood": "hood",
                "Color": "black",
                "Style": "casual",
                "Design": "picture",
                "Gender": "men",
                "Closure": "no closure",
                "Sleeves": "short sleeves",
                "Category": "Clothing/Upper",
                "Material": "cotton",
                "Neckline": "back",
                "Subcategory": "t-shirts",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 16,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 1,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263746,
            "sku": "325d97d29eded1334a6ac239a1dd9e8e-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/straight-leg-printed-pu-trousers/BMM69414.html?color=144",
            "name": "Straight Leg Printed Pu Trousers",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "multi",
            "openai_category": null,
            "category_id": null,
            "category": "Straight-leg trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm69414_multi_xl?$product_image_main$",
            "price": "35.00",
            "sale_price": "10.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/hGBM99ZAyK0Z_ju2dcfuN/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/hGBM99ZAyK0Z_ju2dcfuN/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263747,
            "sku": "81e621808d050bcca3752dd2f2373b5c-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/regular-fit-waffle-knit-jumper/BMM74797.html?color=849",
            "name": "Regular Fit Waffle Knit Jumper",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "slate grey",
            "openai_category": null,
            "category_id": null,
            "category": "Knitted jumpers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm74797_slate%20grey_xl?$product_image_main$",
            "price": "20.00",
            "sale_price": "10.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/OWTmsItO6Wqz5fEB5I-wI/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/OWTmsItO6Wqz5fEB5I-wI/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263748,
            "sku": "8eb3bda7e31512930728d2701ac1d405-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/oversized-boxy-brushed-graphic-knitted-jumper/BMM74581.html?color=115",
            "name": "Oversized Boxy Brushed Graphic Knitted Jumper",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "charcoal",
            "openai_category": null,
            "category_id": null,
            "category": "Knitted jumpers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm74581_charcoal_xl?$product_image_main$",
            "price": "30.00",
            "sale_price": "9.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/GPvmVo1pBQhlyTkPfbdTz/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/GPvmVo1pBQhlyTkPfbdTz/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263749,
            "sku": "027ae4ea990f2b0d4f8e7335c33dc2c0-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/oversized-boxy-bonded-scuba-harrington-set/BMM77897.html?color=165",
            "name": "Oversized Boxy Bonded Scuba Harrington Set",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "stone",
            "openai_category": null,
            "category_id": null,
            "category": "Harrington jackets",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm77897_stone_xl?$product_image_main$",
            "price": "50.00",
            "sale_price": "20.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/3_iPiLOfxN0DrHPNXAYDs/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/3_iPiLOfxN0DrHPNXAYDs/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263750,
            "sku": "169124142e6d496c7e956e5062769742-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/oversized-ombre-print-ski-puffer-jacket/BMM69405.html?color=105",
            "name": "Oversized Ombre Print Ski Puffer Jacket",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Jackets",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm69405_black_xl?$product_image_main$",
            "price": "75.00",
            "sale_price": "22.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/v33DtPZ6J8DVwRLewC8iJ/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/v33DtPZ6J8DVwRLewC8iJ/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263751,
            "sku": "8331a4cccba2619a0027389dd782360e-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/relaxed-rigid-distressed-seam-denim-jean/BMM67988.html?color=436",
            "name": "Relaxed Rigid Distressed Seam Denim Jean",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "washed black",
            "openai_category": null,
            "category_id": null,
            "category": "Jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm67988_washed%20black_xl?$product_image_main$",
            "price": "40.00",
            "sale_price": "12.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/Gw-KhDFPnJS9eCwWlIAfq/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/Gw-KhDFPnJS9eCwWlIAfq/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263752,
            "sku": "bbb96c9e8f3256ccd6866436617e3c89-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/comfort-waist-belted-twill-jorts/BMM77760.html?color=105",
            "name": "Comfort Waist Belted Twill Jorts",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Denim shorts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm77760_black_xl?$product_image_main$",
            "price": "20.00",
            "sale_price": "6.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/Of9JnYkZIzcJRBdyAUvv8/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/Of9JnYkZIzcJRBdyAUvv8/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263753,
            "sku": "6b7d7dfd15b84320bdf5cb1b9e256d0c-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/oversized-boxy-hooded-gusset-tracksuit/BMM54239.html?color=156",
            "name": "Oversized Boxy Hooded Gusset Tracksuit",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "purple",
            "openai_category": null,
            "category_id": null,
            "category": "Tracksuits",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm54239_purple_xl?$product_image_main$",
            "price": "45.00",
            "sale_price": "20.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/lncJZ--7pxMDi5HUDcJHa/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/lncJZ--7pxMDi5HUDcJHa/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263754,
            "sku": "bdbdf72dc028c36a4e60b84ba2680987-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/boxy-boucle-knit-extended-neck-jumper/BMM58831.html?color=115",
            "name": "Boxy Boucle Knit Extended Neck Jumper",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "charcoal",
            "openai_category": null,
            "category_id": null,
            "category": "Knitted jumpers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm58831_charcoal_xl?$product_image_main$",
            "price": "25.00",
            "sale_price": "12.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/f6uUFrzSrKhTPjYMXqexV/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/f6uUFrzSrKhTPjYMXqexV/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263755,
            "sku": "84a8f291aa8b05c4c2dcb37ce8398e2b-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/oversized-zip-through-badge-denim-shirt/BMM90000.html?color=132",
            "name": "Oversized Zip Through Badge Denim Shirt",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "indigo",
            "openai_category": null,
            "category_id": null,
            "category": "Shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm90000_indigo_xl?$product_image_main$",
            "price": "28.00",
            "sale_price": "14.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/U-ResPnVYECGJCyiYh7X0/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/U-ResPnVYECGJCyiYh7X0/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263756,
            "sku": "0b13a76527611063a759c5c87831240c-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/fixed-waist-relaxed-raw-hem-washed-trouser/BMM81645.html?color=109",
            "name": "Fixed Waist Relaxed Raw Hem Washed Trouser",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "brown",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm81645_brown_xl?$product_image_main$",
            "price": "30.00",
            "sale_price": "9.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/JDUAmiINPM_HAeWFFulMD/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/JDUAmiINPM_HAeWFFulMD/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263757,
            "sku": "c9cb6593cf6489d6d26db15ff8ef87eb-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/man-tab-colour-block-fleece-jacket-in-grey/BMM81619.html?color=131",
            "name": "Man Tab Colour Block Fleece Jacket In Grey",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "grey",
            "openai_category": null,
            "category_id": null,
            "category": "Jackets",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm81619_grey_xl?$product_image_main$",
            "price": "45.00",
            "sale_price": "13.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/C27UhficiXwT-vJB74Naa/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/C27UhficiXwT-vJB74Naa/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263759,
            "sku": "fbfe88ba346dc267ff0435efa9ef0e90-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/regular-cable-knit-jumper/BMM93956.html?color=186",
            "name": "Regular Cable Knit Jumper",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "chocolate",
            "openai_category": null,
            "category_id": null,
            "category": "Knitted jumpers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm93956_chocolate_xl?$product_image_main$",
            "price": "25.00",
            "sale_price": "12.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/-_HMvTW3G_qCxw0uI1vY-/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/-_HMvTW3G_qCxw0uI1vY-/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263760,
            "sku": "fc57588986c96c2fa9e245a069d64a5f-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/high-shine-quilted-hooded-jacket-in-black/BMM79845.html?color=105",
            "name": "High Shine Quilted Hooded Jacket In Black",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Jackets",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm79845_black_xl?$product_image_main$",
            "price": "40.00",
            "sale_price": "12.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/cFNiQvSlCxSq_WoTME8Iz/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/cFNiQvSlCxSq_WoTME8Iz/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174639105,
            "sku": "40df0119f34679cbe5b0e4707b8e4d2c-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/man-boxy-fit-funnel-neck-puffer-coat-in-slate/BMM84691.html?color=212",
            "name": "Man Boxy Fit Funnel Neck Puffer Coat In Slate",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "slate",
            "openai_category": null,
            "category_id": null,
            "category": "Coats",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm84691_slate_xl?$product_image_main$",
            "price": "50.00",
            "sale_price": "25.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/DYMdVeFkIg8-6qTeU3ao7/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/DYMdVeFkIg8-6qTeU3ao7/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-24T18:02:14.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 174263761,
            "sku": "fe5576630df5ab04b5e413ce41f61e3e-1058",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1058,
            "link": "https://www.boohooman.com/man-heat-seal-hooded-puffer-coat-in-light-blue/BMM81610.html?color=564",
            "name": "Man Heat Seal Hooded Puffer Coat In Light Blue",
            "status": 1,
            "version": "202503251029",
            "gender": "MEN",
            "color": "light blue",
            "openai_category": null,
            "category_id": null,
            "category": "Coats",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohooman.com/i/boohooman/bmm81610_light%20blue_xl?$product_image_main$",
            "price": "70.00",
            "sale_price": "20.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/R58zFgVFeK9I1sQXlAEx6/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/R58zFgVFeK9I1sQXlAEx6/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-03-20T18:02:13.000000Z",
            "updated_at": "2025-03-25T10:30:59.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        }
    ],
    "info": {
        "current_page": "1",
        "total_pages": 32,
        "total_items": 624,
        "page_count": 20
    }
}

export const demoMostViewedFeedItems = {
    "items": [
        {
            "id": 168622283,
            "sku": "483f6d717ccaa4200f5759704c54f02a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-nirvana-face-license-t-shirt/MZZ86578.html?color=173",
            "name": "Oversized Nirvana Face License T-shirt",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "white",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/mzz86578_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "22.00",
            "sale_price": "15.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 68,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 11,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 1,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 1,
                        "percent": 100
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622286,
            "sku": "7a7f34136a6ab5d13899e1054b68f02e-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/man-active-gym-cargo-jogger/BMM48064.html?color=265",
            "name": "Man Active Gym Cargo Jogger",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "grey marl",
            "openai_category": null,
            "category_id": null,
            "category": "Joggers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm48064_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/hF7R-U_csQyf2NYq8Purx/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/hF7R-U_csQyf2NYq8Purx/original.jpg",
            "tags": [
                {
                    "color": "gray",
                    "category": "sweatpants"
                },
                {
                    "color": "white, gray",
                    "category": "sneakers"
                },
                {
                    "color": "white",
                    "category": "sneakers"
                }
            ],
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "straight",
                "Rise": "low rise",
                "Color": "grey",
                "Style": "sport",
                "Design": "melange",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Material": "denim",
                "Subcategory": "sweat pants",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 27,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622305,
            "sku": "59052fce63cf303545bcbff3b44529cc-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/boxy-long-sleeve-knitted-revere-polo/BMM58817.html?color=265",
            "name": "Boxy Long Sleeve Knitted Revere Polo",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "grey marl",
            "openai_category": null,
            "category_id": null,
            "category": "Long-sleeved tops",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm58817_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "25.00",
            "sale_price": "17.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/JOqOgl7dG71ir9fQUgpmu/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/JOqOgl7dG71ir9fQUgpmu/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 27,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622270,
            "sku": "b41223779c63f2a82614f5375062995a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/man-active-oversized-one-more-rep-t-shirt/BMM80340.html?color=265",
            "name": "Man Active Oversized One More Rep T-shirt",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "grey marl",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm80340_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "16.00",
            "sale_price": "11.20",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/tXYM5QgBvgdIrJexSa5A0/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/tXYM5QgBvgdIrJexSa5A0/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 26,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 1,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 1,
                        "percent": 100
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622301,
            "sku": "3a2cb8d57836c4d326051df6355d56aa-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/relaxed-rigid-overdyed-carpenter-jeans/BMM68119.html?color=508",
            "name": "Relaxed Rigid Overdyed Carpenter Jeans",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "light grey",
            "openai_category": null,
            "category_id": null,
            "category": "Jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm68119_light%20grey_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/S_m4SKeufV_IqxKon3cJU/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/S_m4SKeufV_IqxKon3cJU/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 26,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622281,
            "sku": "26cd6e357d11ecb948d95e45391877ec-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/slim-stacked-flare-star-print-gusset-jogger/BMM59070.html?color=105",
            "name": "Slim Stacked Flare Star Print Gusset Jogger",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Joggers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm59070_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "20.00",
            "sale_price": "14.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/toyg2XwxbxWdkcRlhIaF-/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/toyg2XwxbxWdkcRlhIaF-/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "straight",
                "Rise": "can't tell",
                "Color": "black",
                "Style": "sport",
                "Design": "logo",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Material": "cotton",
                "Subcategory": "sweat pants",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 25,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622296,
            "sku": "2aa50c5a537d9b0c06285385bf37a55f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/extreme-baggy-rigid-multi-cargo-pocket-trousers/BMM75334.html?color=131",
            "name": "Extreme Baggy Rigid Multi Cargo Pocket Trousers",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "grey",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm75334_grey_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "32.00",
            "sale_price": "22.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/9iYgQIhYSIT9J6spmpI1U/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/9iYgQIhYSIT9J6spmpI1U/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 24,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622288,
            "sku": "a439296d9049db2da69ab4954c140b5a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/extreme-baggy-rigid-multi-cargo-pocket-trousers/BMM75337.html?color=105",
            "name": "Extreme Baggy Rigid Multi Cargo Pocket Trousers",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm75337_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/o7eULQ2gYsDMM5M4yWa2K/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/o7eULQ2gYsDMM5M4yWa2K/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 23,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622311,
            "sku": "6d2ed8d57e56121e3ede65b0acc76b25-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/straight-fixed-waist-tailored-trouser/BMM73196.html?color=105",
            "name": "Straight Fixed Waist Tailored Trouser",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm73196_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/thLoFiV7Dn1KxRwg_bRrj/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/thLoFiV7Dn1KxRwg_bRrj/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 23,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622271,
            "sku": "de63c267d7e814218df7b46c4c2d375a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/relaxed-rigid-flare-frayed-edge-cargo-jeans/BMM53063.html?color=436",
            "name": "Relaxed Rigid Flare Frayed Edge Cargo Jeans",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "washed black",
            "openai_category": null,
            "category_id": null,
            "category": "Flared jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm53063_washed%20black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/qx8wqezA2SP-CpPT2PHSp/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/qx8wqezA2SP-CpPT2PHSp/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "wide leg",
                "Rise": "can't tell",
                "Color": "black",
                "Style": "sport",
                "Design": "plain",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Subcategory": "cargo",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 22,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622287,
            "sku": "ba95261a564e0b659042daae3c61285e-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-boxy-puff-print-acid-wash-hoodie/BMM76699.html?color=105",
            "name": "Oversized Boxy Puff Print Acid Wash Hoodie",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Hoodies & sweatshirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm76699_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/OHY1P9xl2Q7g_gn8k-uj9/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/OHY1P9xl2Q7g_gn8k-uj9/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 22,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722701,
            "sku": "5bcce1c0ea7ca56762e884ab88591b7b-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/high-rise-tapered-crop-tailored-trouser/BMM70640.html?color=105",
            "name": "High Rise Tapered Crop Tailored Trouser",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm70640_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/-0eulXuK7tWtJO3snQVqN/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/-0eulXuK7tWtJO3snQVqN/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 21,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622278,
            "sku": "efa02d8a88bbb13f4018c197745cc8dc-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-washed-wyoming-print-t-shirt/BMM11141.html?color=186",
            "name": "Oversized Washed Wyoming Print T-shirt",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "chocolate",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm11141_chocolate_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "16.00",
            "sale_price": "11.20",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/psAecY_VJZ6TFU7jbK59C/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/psAecY_VJZ6TFU7jbK59C/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 21,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722708,
            "sku": "5501110d3af819509f7a9d614daf7c2f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/long-sleeve-contrast-collar-knitted-shirt-in-black/BMM75282.html?color=105",
            "name": "Long Sleeve Contrast Collar Knitted Shirt In Black",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Long-sleeved t-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm75282_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 21,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 1,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722707,
            "sku": "ab76efe61328e69321a83f916e154d74-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/slim-fit-pleated-trousers/BMM56361.html?color=105",
            "name": "Slim Fit Pleated Trousers",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm56361_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "35.00",
            "sale_price": "24.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/9oW35T1s5dRUp9CoP9yBR/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/9oW35T1s5dRUp9CoP9yBR/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622272,
            "sku": "cb4aa1acf7acdabf400a7e373e57e81b-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/man-active-gym-muscle-fit-ribbed-vest/BMM32518.html?color=173",
            "name": "Man Active Gym Muscle Fit Ribbed Vest",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "white",
            "openai_category": null,
            "category_id": null,
            "category": "Vest tops",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm32518_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "10.00",
            "sale_price": "7.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_jCAaUvZMR772X-qlhm03N/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_jCAaUvZMR772X-qlhm03N/original.jpg",
            "tags": {
                "color": "white",
                "category": "tank-top",
                "attributes": [
                    {
                        "type": "neckline_type",
                        "values": [
                            {
                                "score": 0.93851,
                                "attribute": "round-neck"
                            }
                        ]
                    },
                    {
                        "type": "tank_type",
                        "values": [
                            {
                                "score": 0.99975,
                                "attribute": "sleeveless"
                            }
                        ]
                    },
                    {
                        "type": "tops_fit",
                        "values": [
                            {
                                "score": 0.82562,
                                "attribute": "bodycon-tops"
                            }
                        ]
                    },
                    {
                        "type": "tops_length",
                        "values": [
                            {
                                "score": 0.95596,
                                "attribute": "short"
                            }
                        ]
                    },
                    {
                        "type": "colors",
                        "values": [
                            {
                                "score": 0.99918,
                                "attribute": "white"
                            }
                        ]
                    },
                    {
                        "type": "pattern",
                        "values": [
                            {
                                "score": 0.34309,
                                "attribute": "horizontal-stripes"
                            }
                        ]
                    },
                    {
                        "type": "material",
                        "values": [
                            {
                                "score": 1,
                                "attribute": "cotton"
                            }
                        ]
                    },
                    {
                        "type": "style",
                        "values": [
                            {
                                "score": 0.81511,
                                "attribute": "casual"
                            }
                        ]
                    },
                    {
                        "type": "occasion",
                        "values": [
                            {
                                "score": 0.81511,
                                "attribute": "casual"
                            }
                        ]
                    }
                ]
            },
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622280,
            "sku": "08c389d8e996ffcbc7e08e7eee1bd82a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/slim-rigid-jean/BMM54663.html?color=564",
            "name": "Slim Rigid Jean",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "light blue",
            "openai_category": null,
            "category_id": null,
            "category": "Slim fit jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm54663_light%20blue_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "15.00",
            "sale_price": "15.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/wIYg_ZQp14x6myNELrksF/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/wIYg_ZQp14x6myNELrksF/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622299,
            "sku": "1cd192c8ed10d5fbbd41d25de389823c-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/elasticated-waist-split-hem-smart-trousers/BMM76307.html?color=105",
            "name": "Elasticated Waist Split Hem Smart Trousers",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm76307_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/D6mGR1HaJ9Izr9bPSmR9Y/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/D6mGR1HaJ9Izr9bPSmR9Y/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622302,
            "sku": "14f43803230ff0badea1ae3e1cbeca94-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/skinny-stacked-distressed-ripped-jeans/BMM52280.html?color=847",
            "name": "Skinny Stacked Distressed Ripped Jeans",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "true black",
            "openai_category": null,
            "category_id": null,
            "category": "Ripped jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm52280_true%20black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/-Ct51xnPEqRzHJ25pV21y/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/-Ct51xnPEqRzHJ25pV21y/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "slim",
                "Rise": "can't tell",
                "Color": "black",
                "Style": "sport",
                "Design": "plain",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Material": "denim",
                "Subcategory": "cargo",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622307,
            "sku": "53c468bd6ccb07991ba42b57b84c6238-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/skinny-stacked-distressed-ripped-jeans/BMM51369.html?color=847",
            "name": "Skinny Stacked Distressed Ripped Jeans",
            "status": 1,
            "version": "202503251202",
            "gender": "MEN",
            "color": "true black",
            "openai_category": null,
            "category_id": null,
            "category": "Ripped jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm51369_true%20black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/lvWHHQVdx9ZsCkIt1oK7b/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/lvWHHQVdx9ZsCkIt1oK7b/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "straight",
                "Rise": "can't tell",
                "Color": "black",
                "Style": "casual",
                "Design": "plain",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Material": "denim",
                "Subcategory": "cargo",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-03-25T12:03:10.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-03-25",
                    "to": "2025-03-25"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        }
    ],
    "info": {
        "current_page": "1",
        "total_pages": 32,
        "total_items": 624,
        "page_count": 20
    }
}

export const demoFeedsCountsStats = {
    "type": "week",
    "stats": [
      {
        "period": {
          "from": "2024-12-30",
          "to": "2025-01-05"
        },
        "value": 0,
        "formatted_period": "2025-01-W1"
      },
      {
        "period": {
          "from": "2025-01-06",
          "to": "2025-01-12"
        },
        "value": 0,
        "formatted_period": "2025-01-W2"
      },
      {
        "period": {
          "from": "2025-01-13",
          "to": "2025-01-19"
        },
        "value": 0,
        "formatted_period": "2025-01-W3"
      },
      {
        "period": {
          "from": "2025-01-20",
          "to": "2025-01-26"
        },
        "value": 0,
        "formatted_period": "2025-01-W4"
      },
      {
        "period": {
          "from": "2025-01-27",
          "to": "2025-02-02"
        },
        "value": 0,
        "formatted_period": "2025-02-W1"
      },
      {
        "period": {
          "from": "2025-02-03",
          "to": "2025-02-09"
        },
        "value": 0,
        "formatted_period": "2025-02-W2"
      },
      {
        "period": {
          "from": "2025-02-10",
          "to": "2025-02-16"
        },
        "value": 523,
        "formatted_period": "2025-02-W3"
      },
      {
        "period": {
          "from": "2025-02-17",
          "to": "2025-02-23"
        },
        "value": 679,
        "formatted_period": "2025-02-W4"
      },
      {
        "period": {
          "from": "2025-02-24",
          "to": "2025-03-02"
        },
        "value": 657,
        "formatted_period": "2025-03-W1"
      },
      {
        "period": {
          "from": "2025-03-03",
          "to": "2025-03-09"
        },
        "value": 663,
        "formatted_period": "2025-03-W2"
      },
      {
        "period": {
          "from": "2025-03-10",
          "to": "2025-03-16"
        },
        "value": 653,
        "formatted_period": "2025-03-W3"
      },
      {
        "period": {
          "from": "2025-03-17",
          "to": "2025-03-23"
        },
        "value": 637,
        "formatted_period": "2025-03-W4"
      },
      {
        "period": {
          "from": "2025-03-24",
          "to": "2025-03-30"
        },
        "value": 621,
        "formatted_period": "2025-03-W5"
      }
    ]
  }

export const demoFeedsItemsClicks = {
    "type": "week",
    "field": "clicks",
    "stats": [
      {
        "period": {
          "from": "2024-12-30",
          "to": "2025-01-05"
        },
        "value": 0,
        "formatted_period": "2025-01-W1"
      },
      {
        "period": {
          "from": "2025-01-06",
          "to": "2025-01-12"
        },
        "value": 0,
        "formatted_period": "2025-01-W2"
      },
      {
        "period": {
          "from": "2025-01-13",
          "to": "2025-01-19"
        },
        "value": 0,
        "formatted_period": "2025-01-W3"
      },
      {
        "period": {
          "from": "2025-01-20",
          "to": "2025-01-26"
        },
        "value": 0,
        "formatted_period": "2025-01-W4"
      },
      {
        "period": {
          "from": "2025-01-27",
          "to": "2025-02-02"
        },
        "value": 0,
        "formatted_period": "2025-02-W1"
      },
      {
        "period": {
          "from": "2025-02-03",
          "to": "2025-02-09"
        },
        "value": 0,
        "formatted_period": "2025-02-W2"
      },
      {
        "period": {
          "from": "2025-02-10",
          "to": "2025-02-16"
        },
        "value": 0,
        "formatted_period": "2025-02-W3"
      },
      {
        "period": {
          "from": "2025-02-17",
          "to": "2025-02-23"
        },
        "value": 6,
        "formatted_period": "2025-02-W4"
      },
      {
        "period": {
          "from": "2025-02-24",
          "to": "2025-03-02"
        },
        "value": 0,
        "formatted_period": "2025-03-W1"
      },
      {
        "period": {
          "from": "2025-03-03",
          "to": "2025-03-09"
        },
        "value": 10,
        "formatted_period": "2025-03-W2"
      },
      {
        "period": {
          "from": "2025-03-10",
          "to": "2025-03-16"
        },
        "value": 3,
        "formatted_period": "2025-03-W3"
      },
      {
        "period": {
          "from": "2025-03-17",
          "to": "2025-03-23"
        },
        "value": 3,
        "formatted_period": "2025-03-W4"
      },
      {
        "period": {
          "from": "2025-03-24",
          "to": "2025-03-30"
        },
        "value": 0,
        "formatted_period": "2025-03-W5"
      }
    ]
  }

  export const mostDisplayedCouponsDemoStats = {
    "period": {
        "to": "2025-04-07",
        "from": "2025-03-31"
    },
    "stats": [
        {
            "id": 1,
            "name": "FLASHSALE15",
            "description": "Get 15% off your purchase during our 24-hour flash sale!",
            "displayed_count": 497
        },
        {
            "id": 2,
            "name": "NEW10OFF",
            "description": "Enjoy 10% off your first order as a new customer.",
            "displayed_count": 466
        },
        {
            "id": 3,
            "name": "FREESHIP50",
            "description": "Free shipping on orders over $50.",
            "displayed_count": 421
        },
        {
            "id": 4,
            "name": "BUY2GET1FREE",
            "description": "Buy 2 items, get 1 free on select products.",
            "displayed_count": 379
        },
        {
            "id": 5,
            "name": "SUMMER20",
            "description": "Save 20% on all summer collection items.",
            "displayed_count": 311
        },
        {
            "id": 6,
            "name": "LOYALTY25",
            "description": "Exclusive 25% discount for our loyal customers.",
            "displayed_count": 205
        },
        {
            "id": 7,
            "name": "BUNDLEDEAL",
            "description": "Build your own bundle and save 15% on the total.",
            "displayed_count": 142
        },
        {
            "id": 8,
            "name": "BACKTOSCHOOL",
            "description": "Get ready for school with 10% off on essential supplies.",
            "displayed_count": 87
        },
        {
            "id": 9,
            "name": "CLEARANCE50",
            "description": "Up to 50% off on clearance items while supplies last.",
            "displayed_count": 88
        },
        {
            "id": 10,
            "name": "SOCIALFOLLOW",
            "description": "Follow us on social media and use this code for a special surprise discount!",
            "displayed_count": 61
        }
    ]
}